<fieldset class="grid" aria-label="Einstellungen zur Rechnungsstellung" data-test-id="aufgabe-rechnungsstellung-root">
	<div class="row">
		<mat-radio-group aria-label="Bitte Option wählen" class="column" [formControl]="bodyControls.erledigung">
			<mat-radio-button
				color="primary"
				class="focus-inwards-dark"
				[value]="erledigung.ERLEDIGT"
				data-test-id="erledigt-radio-button">
				erledigt
			</mat-radio-button>
			<mat-radio-button
				color="primary"
				class="focus-inwards-dark"
				[value]="erledigung.SPAETER"
				data-test-id="spaeter-radio-button">
				später
			</mat-radio-button>
		</mat-radio-group>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.RECHNUNGSSTELLUNG" />
</fieldset>
